// import React from 'react';
// import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
// import ButtonDahbaord from 'components/ButtonDahbaord/ButtonDahbaord';
// import { IoCloseOutline } from "react-icons/io5";
// import { formatDate, formatTimeInTimezone } from 'pages/utils/formdatedynamics';
// import { getReadableOrderId } from 'pages/utils/HelperFun';
// const toNum = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0; };

// const getInitials = (name = '') =>
//   name.split(' ').slice(0, 2).map((w) => w[0]?.toUpperCase()).join('');

// const deriveBilling = (order) => {
//   if (!order) return {};

//   const cost        = toNum(order.cost);
//   const discountAmt = toNum(order.discount);
//   const addOns      = Array.isArray(order.selectedAddOns)
//     ? order.selectedAddOns
//     : Array.isArray(order.orderDetails?.addOns)
//     ? order.orderDetails.addOns
//     : [];
//   const addOnsTotal = toNum(order.addOnsTotal ?? order.orderDetails?.addOnsTotal)
//     || addOns.reduce((s, a) => s + toNum(a.price), 0);

//   // ✅ Platform fee: 5% clamped min 1.50 – max 5.00 AED
//   const rawServiceFee = cost * 0.05;
//   const platformFee   = parseFloat(Math.min(5.00, Math.max(1.50, rawServiceFee)).toFixed(2));

//   const vatFee = 0;

//   const customerTotal = cost + addOnsTotal - discountAmt - vatFee;
//   const shopTotal     = customerTotal - platformFee;

//   // Promo text
//   let promoCodeText = 'No Promo Code Applied';
//   const promo = order.promoCode;
//   if (promo?.promoCode) {
//     promoCodeText = promo.Discounttype === 'percentage'
//       ? `${promo.promoCode} (${promo.discount}% off)`
//       : `${promo.promoCode} (Fixed: −${promo.discount} AED)`;
//   }

//   return {
//     cost:          cost.toFixed(2),
//     discountAmt:   discountAmt.toFixed(2),
//     addOnsTotal:   addOnsTotal.toFixed(2),
//     platformFee:   platformFee.toFixed(2),
//     customerTotal: customerTotal.toFixed(2),
//     shopTotal:     shopTotal.toFixed(2),
//     promoCodeText,
//     addOns,
//     feeLabel:    order.fee    || '5%',
//     vatFeeLabel: order.vatFee || '0%',
//   };
// };

// // ─── sub-components ───────────────────────────────────────────────────────────

// const Field = ({ label, children }) => (
//   <div style={{ display: 'flex', flexDirection: 'column', gap: 3, marginBottom: 8 }}>
//     <span style={{ fontSize: 11, color: '#888' }}>{label}</span>
//     <div style={{
//       fontSize: 13, color: '#1a1a1a',
//       background: '#fafaf9', border: '0.5px solid #ececea',
//       borderRadius: 8, padding: '7px 10px',
//       minHeight: 32, display: 'flex', alignItems: 'center', flexWrap: 'wrap',
//     }}>
//       {children ?? '—'}
//     </div>
//   </div>
// );

// const HighlightField = ({ label, children, color = '#185FA5' }) => (
//   <div style={{ display: 'flex', flexDirection: 'column', gap: 3, marginBottom: 8 }}>
//     <span style={{ fontSize: 11, color: '#888' }}>{label}</span>
//     <div style={{
//       fontSize: 13, fontWeight: 600, color,
//       background: color === '#185FA5' ? '#EEF5FF' : '#FFF7ED',
//       border: `0.5px solid ${color === '#185FA5' ? '#C8DFF5' : '#FCD38A'}`,
//       borderRadius: 8, padding: '7px 10px',
//       minHeight: 32, display: 'flex', alignItems: 'center',
//     }}>
//       {children ?? '—'}
//     </div>
//   </div>
// );

// const SectionTitle = ({ children }) => (
//   <p style={{
//     fontSize: 10, fontWeight: 700, color: '#c0c0c0',
//     textTransform: 'uppercase', letterSpacing: '0.09em', margin: '0 0 10px',
//   }}>
//     {children}
//   </p>
// );

// const Divider = () => (
//   <hr style={{ border: 'none', borderTop: '0.5px solid #f0f0f0', margin: '12px 0' }} />
// );

// const BillingBadge = ({ status }) => {
//   const isPaid = status?.toLowerCase() === 'paid';
//   return (
//     <span style={{
//       display: 'inline-flex', alignItems: 'center',
//       padding: '2px 10px', borderRadius: 100,
//       fontSize: 11, fontWeight: 600,
//       background: isPaid ? '#F0FBE8' : '#FFF7ED',
//       color:      isPaid ? '#2E7D10' : '#B45309',
//       border:     `0.5px solid ${isPaid ? '#B6E08A' : '#FCD38A'}`,
//     }}>
//       {status || '—'}
//     </span>
//   );
// };

// const StatusBadge = ({ status }) => {
//   const map = {
//     completed: { bg: '#F0FBE8', color: '#2E7D10', border: '#B6E08A' },
//     pending:   { bg: '#FFF7ED', color: '#B45309', border: '#FCD38A' },
//     cancelled: { bg: '#FEF2F2', color: '#991B1B', border: '#FCA5A5' },
//   };
//   const s = map[status?.toLowerCase()] || { bg: '#f3f4f6', color: '#555', border: '#e5e7eb' };
//   return (
//     <span style={{
//       display: 'inline-flex', alignItems: 'center',
//       padding: '3px 10px', borderRadius: 100,
//       fontSize: 11, fontWeight: 600,
//       background: s.bg, color: s.color, border: `0.5px solid ${s.border}`,
//     }}>
//       {status || '—'}
//     </span>
//   );
// };

// // ─── main ─────────────────────────────────────────────────────────────────────

// const PopupCustomer = ({ show, onHide, popupData, onViewInvoice, onDeleteInoive, customer, item }) => {
//   const order = Array.isArray(popupData) ? popupData[0] : popupData;
//   if (!order) return null;

//   const customerName =
//     item?.customerId?.fullName ||
//     order?.customerId?.fullName ||
//     order?.customerId?.username ||
//     'Customer';

//   const initials = getInitials(customerName);
//   const serviceName = order?.serviceVariant?.variantName || order?.carServiceName || 'Service';

//   const {
//     cost, discountAmt, addOnsTotal, platformFee,
//     customerTotal, shopTotal,
//     promoCodeText, addOns, feeLabel, vatFeeLabel,
//   } = deriveBilling(order);

//   const styles = {
//     header: {
//       display: 'flex', alignItems: 'center', gap: 10,
//       padding: '14px 20px', borderBottom: '0.5px solid #f0f0f0',
//     },
//     avatar: {
//       width: 38, height: 38, borderRadius: '50%',
//       background: 'linear-gradient(135deg, #EEF5FF 0%, #ddeeff 100%)',
//       display: 'flex', alignItems: 'center', justifyContent: 'center',
//       fontSize: 13, fontWeight: 700, color: '#185FA5', flexShrink: 0,
//     },
//     twoCol: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 },
//     col: { display: 'flex', flexDirection: 'column' },
//     footer: {
//       display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//       padding: '12px 20px', borderTop: '0.5px solid #f0f0f0',
//       gap: 8, width: '100%', background: '#fafaf9',
//     },
//     btnGroup: { display: 'flex', gap: 8 },
//   };

//   return (
//     <Dialog
//       open={show} onClose={onHide} fullWidth maxWidth="md"
//       PaperProps={{ style: { borderRadius: 16, boxShadow: '0 12px 50px rgba(0,0,0,0.12)' } }}
//     >
//       {/* ── Header ── */}
//       <DialogTitle style={{ padding: 0 }}>
//         <div style={styles.header}>
//           <div style={styles.avatar}>{initials}</div>
//           <div style={{ flex: 1 }}>
//             <p style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#111' }}>{customerName}</p>
//             <p style={{ margin: 0, fontSize: 11, color: '#bbb' }}>{getReadableOrderId(order?._id)}</p>
//           </div>
//           <StatusBadge status={order?.status} />
//           <IconButton size="small" onClick={onHide} style={{ marginLeft: 4, padding: 4 }}>
//             <IoCloseOutline size={18} color="#999" />
//           </IconButton>
//         </div>
//       </DialogTitle>

//       {/* ── Body ── */}
//       <DialogContent style={{ padding: '16px 20px' }}>
//         <div style={styles.twoCol}>

//           {/* ══ LEFT: Car + Pricing ══ */}
//           <div style={styles.col}>
//             <SectionTitle>Car details</SectionTitle>
//             <Field label="Customer name">{customerName}</Field>
//             <Field label="Email">{order?.customerId?.email}</Field>
//             <Field label="Car">{order?.vehicleId?.vehicleName}</Field>
//             <Field label="Car type">{order?.vehicleId?.vehicleType}</Field>
//             <Field label="Plate number">{order?.vehicleId?.vehiclePlateNumber}</Field>
//             <Field label="Service">{serviceName}</Field>
//             <Field label="Variant">{order?.serviceVariant?.variantTypeLabel}</Field>
//             {order?.carParkedAt && <Field label="Car parked at">{order.carParkedAt}</Field>}

//             <Divider />
//             <SectionTitle>Pricing breakdown</SectionTitle>

//             <Field label="Shop base price">{cost} AED</Field>

//             {toNum(addOnsTotal) > 0 && (
//               <Field label="Add-ons total">+ {addOnsTotal} AED</Field>
//             )}

//             <Field label="Promo code">{promoCodeText}</Field>

//             {toNum(discountAmt) > 0 && (
//               <Field label="Promo discount">− {discountAmt} AED</Field>
//             )}

//             {/* Platform fee — only for admin/shop view */}
//             {customer !== true && (
//               <>
//                 <HighlightField
//                   label="Washta platform fee (5%  ·  min 1.50 – max 5.00 AED)"
//                   color="#B45309"
//                 >
//                   − {platformFee} AED
//                 </HighlightField>
//                 <Field label="Fee rate">{feeLabel}</Field>
//                 <Field label="VAT fee">{vatFeeLabel}</Field>
//               </>
//             )}

//             {/* Customer total (what customer paid) — visible to admin */}
//             {customer !== true && (
//               <Field label="Customer paid (before Washta fee)">{customerTotal} AED</Field>
//             )}
//           </div>

//           {/* ══ RIGHT: Order + Add-ons ══ */}
//           <div style={styles.col}>
//             <SectionTitle>Order details</SectionTitle>
//             <Field label="Order ID">{getReadableOrderId(order?._id)}</Field>
//             <Field label="Order date">{formatDate(order?.createdAt)}</Field>
//             <Field label="Order time">{formatTimeInTimezone(order?.createdAt)}</Field>
//             <Field label="Billing status"><BillingBadge status={order?.billingStatus} /></Field>
//             <Field label="Payment ID">{order?.paymentId}</Field>
//             <Field label="Paid at">
//               {order?.paidAt ? `${formatDate(order.paidAt)}  ${formatTimeInTimezone(order.paidAt)}` : '—'}
//             </Field>
//             <Field label="Accepted at">
//               {order?.orderAcceptedAt ? `${formatDate(order.orderAcceptedAt)}  ${formatTimeInTimezone(order.orderAcceptedAt)}` : '—'}
//             </Field>
//             <Field label="Completed at">
//               {order?.orderCompleteAt ? `${formatDate(order.orderCompleteAt)}  ${formatTimeInTimezone(order.orderCompleteAt)}` : '—'}
//             </Field>

//             <Divider />
//             <SectionTitle>Add-ons</SectionTitle>
//             {addOns.length > 0
//               ? addOns.map((a, i) => (
//                   <Field key={a?.addonId || a?._id || i} label={a?.name || a?.addOnName || `Add-on ${i + 1}`}>
//                     {toNum(a?.price).toFixed(2)} AED
//                   </Field>
//                 ))
//               : <p style={{ fontSize: 12, color: '#bbb', fontStyle: 'italic', margin: '0 0 8px' }}>No add-ons selected</p>
//             }
//             <Field label="Add-ons total">{addOnsTotal} AED</Field>
//           </div>

//         </div>
//       </DialogContent>

//       {/* ── Footer ── */}
//       <DialogActions style={{ padding: 0 }}>
//         <div style={styles.footer}>
//           <div>
//             <p style={{ fontSize: 10, color: '#bbb', margin: 0, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
//               {customer === true ? 'Total paid' : 'Payment to shop'}
//             </p>
//             <p style={{ fontSize: 22, fontWeight: 700, color: '#111', margin: 0, lineHeight: 1.2 }}>
//               {customer === true ? customerTotal : shopTotal}{' '}
//               <span style={{ fontSize: 12, fontWeight: 400, color: '#bbb' }}>AED</span>
//             </p>
//             {customer !== true && (
//               <p style={{ fontSize: 10, color: '#bbb', margin: '2px 0 0' }}>
//                 After − {platformFee} AED Washta fee
//               </p>
//             )}
//           </div>
//           <div style={styles.btnGroup}>
//             <ButtonDahbaord handleclick={onViewInvoice} textButton="View invoice" height={32} width={120} background="transparent" />
//             <ButtonDahbaord handleclick={onDeleteInoive} textButton="Delete"       height={32} width={80}  background="purple" />
//           </div>
//         </div>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default PopupCustomer;
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import ButtonDahbaord from 'components/ButtonDahbaord/ButtonDahbaord';
import { IoCloseOutline } from "react-icons/io5";
import { formatDate, formatTimeInTimezone } from 'pages/utils/formdatedynamics';
import { getReadableOrderId } from 'pages/utils/HelperFun';

const toNum = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0; };

const getInitials = (name = '') =>
  name.split(' ').slice(0, 2).map((w) => w[0]?.toUpperCase()).join('');

// ─── Billing logic — InvoicePopup ke saath bilkul same ───────────────────────
// platformFee = 5% of cost, clamped min 1.50 – max 5.00 AED
// customerTotal = cost + addOns + platformFee − discount
// shopTotal     = customerTotal − platformFee
const deriveBilling = (order) => {
  if (!order) return {};

  const cost        = toNum(order.cost);
  const discountAmt = toNum(order.discount);
  const addOns      = Array.isArray(order.selectedAddOns)
    ? order.selectedAddOns
    : Array.isArray(order.orderDetails?.addOns)
    ? order.orderDetails.addOns
    : [];
  const addOnsTotal = toNum(order.addOnsTotal ?? order.orderDetails?.addOnsTotal)
    || addOns.reduce((s, a) => s + toNum(a.price), 0);

  const rawServiceFee = cost * 0.05;
  const platformFee   = parseFloat(Math.min(5.00, Math.max(1.50, rawServiceFee)).toFixed(2));
  const vatFee        = 0;

  // Stripe fee: 2.9% of charged amount + AED 0.30 per transaction
  const chargedAmount = cost + addOnsTotal + platformFee - discountAmt;
  const stripeFee     = parseFloat((chargedAmount * 0.029 + 0.30).toFixed(2));

  // Commission: 8% of base cost
  const commission    = parseFloat((cost * 0.08).toFixed(2));

  const customerTotal = cost + addOnsTotal + platformFee - discountAmt - vatFee;
  const shopTotal     = customerTotal - platformFee;
  const washtaNet     = parseFloat((commission + platformFee - stripeFee).toFixed(2));

  let promoCodeText = 'No Promo Code Applied';
  const promo = order.promoCode;
  if (promo?.promoCode) {
    promoCodeText = promo.Discounttype === 'percentage'
      ? `${promo.promoCode} (${promo.discount}% off)`
      : `${promo.promoCode} (Fixed: −${promo.discount} AED)`;
  }

  return {
    cost:          cost.toFixed(2),
    discountAmt:   discountAmt.toFixed(2),
    addOnsTotal:   addOnsTotal.toFixed(2),
    platformFee:   platformFee.toFixed(2),
    stripeFee:     stripeFee.toFixed(2),
    commission:    commission.toFixed(2),
    washtaNet:     washtaNet.toFixed(2),
    customerTotal: customerTotal.toFixed(2),
    shopTotal:     shopTotal.toFixed(2),
    promoCodeText,
    addOns,
    feeLabel:    order.fee    || '5%',
    vatFeeLabel: order.vatFee || '0%',
  };
};

// ─── sub-components ───────────────────────────────────────────────────────────

const Field = ({ label, children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 3, marginBottom: 8 }}>
    <span style={{ fontSize: 11, color: '#888' }}>{label}</span>
    <div style={{
      fontSize: 13, color: '#1a1a1a',
      background: '#fafaf9', border: '0.5px solid #ececea',
      borderRadius: 8, padding: '7px 10px',
      minHeight: 32, display: 'flex', alignItems: 'center', flexWrap: 'wrap',
    }}>
      {children ?? '—'}
    </div>
  </div>
);

const HighlightField = ({ label, children, color = '#185FA5' }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 3, marginBottom: 8 }}>
    <span style={{ fontSize: 11, color: '#888' }}>{label}</span>
    <div style={{
      fontSize: 13, fontWeight: 600, color,
      background: color === '#185FA5' ? '#EEF5FF' : '#FFF7ED',
      border: `0.5px solid ${color === '#185FA5' ? '#C8DFF5' : '#FCD38A'}`,
      borderRadius: 8, padding: '7px 10px',
      minHeight: 32, display: 'flex', alignItems: 'center',
    }}>
      {children ?? '—'}
    </div>
  </div>
);

const SectionTitle = ({ children }) => (
  <p style={{
    fontSize: 10, fontWeight: 700, color: '#c0c0c0',
    textTransform: 'uppercase', letterSpacing: '0.09em', margin: '0 0 10px',
  }}>
    {children}
  </p>
);

const Divider = () => (
  <hr style={{ border: 'none', borderTop: '0.5px solid #f0f0f0', margin: '12px 0' }} />
);

const BillingBadge = ({ status }) => {
  const isPaid = status?.toLowerCase() === 'paid';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '2px 10px', borderRadius: 100,
      fontSize: 11, fontWeight: 600,
      background: isPaid ? '#F0FBE8' : '#FFF7ED',
      color:      isPaid ? '#2E7D10' : '#B45309',
      border:     `0.5px solid ${isPaid ? '#B6E08A' : '#FCD38A'}`,
    }}>
      {status || '—'}
    </span>
  );
};

const StatusBadge = ({ status }) => {
  const map = {
    completed: { bg: '#F0FBE8', color: '#2E7D10', border: '#B6E08A' },
    pending:   { bg: '#FFF7ED', color: '#B45309', border: '#FCD38A' },
    cancelled: { bg: '#FEF2F2', color: '#991B1B', border: '#FCA5A5' },
  };
  const s = map[status?.toLowerCase()] || { bg: '#f3f4f6', color: '#555', border: '#e5e7eb' };
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: '3px 10px', borderRadius: 100,
      fontSize: 11, fontWeight: 600,
      background: s.bg, color: s.color, border: `0.5px solid ${s.border}`,
    }}>
      {status || '—'}
    </span>
  );
};

// ─── main ─────────────────────────────────────────────────────────────────────

const PopupCustomer = ({ show, onHide, popupData, onViewInvoice, onDeleteInoive, customer, item }) => {
  // ✅ KEY FIX: item (clicked card ka data) ko PEHLE use karo
  // popupData sirf tab use hoga jab item available na ho
  const order = item || (Array.isArray(popupData) ? popupData[0] : popupData);
  if (!order) return null;

  const customerName =
    item?.customerId?.fullName ||
    order?.customerId?.fullName ||
    order?.customerId?.username ||
    'Customer';

  const initials = getInitials(customerName);

  // ✅ Service name: item se pehle lo
  const serviceName =
    item?.serviceVariant?.variantName ||
    item?.carServiceName ||
    order?.serviceVariant?.variantName ||
    order?.carServiceName ||
    'Service';

  const {
    cost, discountAmt, addOnsTotal, platformFee,
    stripeFee, commission, washtaNet,
    customerTotal, shopTotal,
    promoCodeText, addOns, feeLabel, vatFeeLabel,
  } = deriveBilling(order);

  const styles = {
    header: {
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '14px 20px', borderBottom: '0.5px solid #f0f0f0',
    },
    avatar: {
      width: 38, height: 38, borderRadius: '50%',
      background: 'linear-gradient(135deg, #EEF5FF 0%, #ddeeff 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 13, fontWeight: 700, color: '#185FA5', flexShrink: 0,
    },
    twoCol: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 },
    col: { display: 'flex', flexDirection: 'column' },
    footer: {
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 20px', borderTop: '0.5px solid #f0f0f0',
      gap: 8, width: '100%', background: '#fafaf9',
    },
    btnGroup: { display: 'flex', gap: 8 },
  };

  return (
    <Dialog
      open={show} onClose={onHide} fullWidth maxWidth="md"
      PaperProps={{ style: { borderRadius: 16, boxShadow: '0 12px 50px rgba(0,0,0,0.12)' } }}
    >
      {/* ── Header ── */}
      <DialogTitle style={{ padding: 0 }}>
        <div style={styles.header}>
          <div style={styles.avatar}>{initials}</div>
          <div style={{ flex: 1 }}>
            <p style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#111' }}>{customerName}</p>
            <p style={{ margin: 0, fontSize: 11, color: '#bbb' }}>{getReadableOrderId(order?._id)}</p>
          </div>
          <StatusBadge status={order?.status} />
          <IconButton size="small" onClick={onHide} style={{ marginLeft: 4, padding: 4 }}>
            <IoCloseOutline size={18} color="#999" />
          </IconButton>
        </div>
      </DialogTitle>

      {/* ── Body ── */}
      <DialogContent style={{ padding: '16px 20px' }}>
        <div style={styles.twoCol}>

          {/* ══ LEFT: Car + Pricing ══ */}
          <div style={styles.col}>
            <SectionTitle>Car details</SectionTitle>
            <Field label="Customer name">{customerName}</Field>
            <Field label="Email">{order?.customerId?.email}</Field>
            <Field label="Car">{order?.vehicleId?.vehicleName}</Field>
            <Field label="Car type">{order?.vehicleId?.vehicleType}</Field>
            <Field label="Plate number">{order?.vehicleId?.vehiclePlateNumber}</Field>
            <Field label="Service">{serviceName}</Field>
            <Field label="Variant">{order?.serviceVariant?.variantTypeLabel}</Field>
            {order?.carParkedAt && <Field label="Car parked at">{order.carParkedAt}</Field>}

            <Divider />
            <SectionTitle>Pricing breakdown</SectionTitle>

            <Field label="Shop base price">{cost} AED</Field>

            {/* ✅ Service Fee — InvoicePopup jaisi */}
            <Field label="Service fee">{platformFee} AED</Field>

            {toNum(addOnsTotal) > 0 && (
              <Field label="Add-ons total">+ {addOnsTotal} AED</Field>
            )}

            <Field label="Promo code">{promoCodeText}</Field>

            {toNum(discountAmt) > 0 && (
              <Field label="Promo discount">− {discountAmt} AED</Field>
            )}

            {/* Platform fee, Stripe fee, Commission — only for admin/shop view */}
            {customer !== true && (
              <>
                <HighlightField
                  label="Washta platform fee (5% · min 1.50 – max 5.00 AED)"
                  color="#B45309"
                >
                  − {platformFee} AED
                </HighlightField>
                <HighlightField
                  label="Stripe processing fee (2.9% + AED 0.30)"
                  color="#dc2626"
                >
                  − {stripeFee} AED
                </HighlightField>
                <HighlightField
                  label="Washta commission (8% of base price)"
                  color="#185FA5"
                >
                  + {commission} AED
                </HighlightField>
                <Field label="Fee rate">{feeLabel}</Field>
                <Field label="VAT fee">{vatFeeLabel}</Field>
                <Field label="Customer paid">{customerTotal} AED</Field>
                <HighlightField label="Washta net (commission + platform − stripe)" color="#1a6641">
                  {washtaNet} AED
                </HighlightField>
              </>
            )}
          </div>

          {/* ══ RIGHT: Order + Add-ons ══ */}
          <div style={styles.col}>
            <SectionTitle>Order details</SectionTitle>
            <Field label="Order ID">{getReadableOrderId(order?._id)}</Field>
            <Field label="Order date">{formatDate(order?.createdAt || order?.date)}</Field>
            <Field label="Order time">{formatTimeInTimezone(order?.createdAt || order?.date)}</Field>
            <Field label="Billing status"><BillingBadge status={order?.billingStatus} /></Field>
            <Field label="Payment ID">{order?.paymentId}</Field>
            <Field label="Paid at">
              {order?.paidAt
                ? `${formatDate(order.paidAt)}  ${formatTimeInTimezone(order.paidAt)}`
                : '—'}
            </Field>
            <Field label="Accepted at">
              {order?.orderAcceptedAt
                ? `${formatDate(order.orderAcceptedAt)}  ${formatTimeInTimezone(order.orderAcceptedAt)}`
                : '—'}
            </Field>
            <Field label="Completed at">
              {order?.orderCompleteAt
                ? `${formatDate(order.orderCompleteAt)}  ${formatTimeInTimezone(order.orderCompleteAt)}`
                : '—'}
            </Field>

            <Divider />
            <SectionTitle>Add-ons</SectionTitle>
            {addOns.length > 0
              ? addOns.map((a, i) => (
                  <Field key={a?.addonId || a?._id || i} label={a?.name || a?.addOnName || `Add-on ${i + 1}`}>
                    {toNum(a?.price).toFixed(2)} AED
                  </Field>
                ))
              : <p style={{ fontSize: 12, color: '#bbb', fontStyle: 'italic', margin: '0 0 8px' }}>No add-ons selected</p>
            }
            <Field label="Add-ons total">{addOnsTotal} AED</Field>
          </div>

        </div>
      </DialogContent>

      {/* ── Footer ── */}
      <DialogActions style={{ padding: 0 }}>
        <div style={styles.footer}>
          <div>
            <p style={{ fontSize: 10, color: '#bbb', margin: 0, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
              {customer === true ? 'Total paid' : 'Payment to shop'}
            </p>
            <p style={{ fontSize: 22, fontWeight: 700, color: '#111', margin: 0, lineHeight: 1.2 }}>
              {customer === true ? customerTotal : shopTotal}{' '}
              <span style={{ fontSize: 12, fontWeight: 400, color: '#bbb' }}>AED</span>
            </p>
            {customer !== true && (
              <p style={{ fontSize: 10, color: '#bbb', margin: '2px 0 0' }}>
                After − {platformFee} AED Washta fee
              </p>
            )}
          </div>
          <div style={styles.btnGroup}>
            <ButtonDahbaord handleclick={onViewInvoice} textButton="View invoice" height={32} width={120} background="transparent" />
            <ButtonDahbaord handleclick={onDeleteInoive} textButton="Delete"       height={32} width={80}  background="purple" />
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default PopupCustomer;